import IconInvoiceBilling from "../../../../../atoms/CustomIcons/IconInvoiceBilling";

export default function InvoicingAndBilling() {
  return (
    <div>
      <h2 className="tabs_content_heading">
        <IconInvoiceBilling /> Invoicing & Billing
      </h2>
      <p className="tabs_content_subheading">
        Customize your invoicing and billing processes.
      </p>
    </div>
  );
}
